module.exports = __webpack_public_path__ + "01-login.jpg?366b7c1c175b2b203c5cc18ad0e0c564";


//////////////////
// WEBPACK FOOTER
// ./src/assets/01-login.jpg
// module id = 678
// module chunks = 0